<template>
  <div class="text-center">
    <v-stepper
      v-model="currentStep"
      :alt-labels="true"
      :flat="true"
      class="status-stepper pb-0"
      :vertical="$vuetify.breakpoint.width < $vuetify.breakpoint.thresholds.md">
      <v-stepper-header
        :class="{ 'flex-column': $vuetify.breakpoint.width < $vuetify.breakpoint.thresholds.md }"
        class="stepper-header">
        <template v-for="(status, index) in statuses">
          <v-divider
            class="divider"
            :key="`${index}-divider`"
            v-if="$vuetify.breakpoint.width >= $vuetify.breakpoint.thresholds.md"
            v-show="index && status.show"></v-divider>

          <v-stepper-step
            v-show="status.show"
            :step="status.stepNumber"
            :class="{
              dense: dense,
              'is-requested': novaCore.isRequested(appointment) && status.name === requestedStatus
            }"
            :complete-icon="getCompletedIcon(status)"
            :complete="status.stepNumber <= currentStep || currentStep === 0"
            :color="status.name.toLowerCase()"
            :alt-labels="true"
            :key="`status-${index}`">
            <div class="text-center">
              <div class="font-weight-medium status-name">
                {{ novaCore.breakWordsAtCaps(status.name) }}
              </div>

              <template v-if="displayTime(status)">
                <div class="d-flex flex-wrap-nowrap align-center">
                  <div
                    class="font-size-x-small full-width"
                    v-if="appointment.statusTimeline[status.name]">
                    {{
                      formatDateTime(
                        appointment.statusTimeline[status.name],
                        novaCore.LuxonDateTimeFormats.MonthDayYearSlashedTimeAMPM,
                        novaCore.LuxonDateTimeFormats.MonthDayYearSlashedTime24
                      )
                    }}
                  </div>
                </div>
                <div class="caption text-uppercase" v-html="timeDiffInfo(status.name)"></div>
              </template>
            </div>
          </v-stepper-step>
        </template>
      </v-stepper-header>
    </v-stepper>
  </div>
</template>

<script>
import statusManagerMixin from '@satellite/components/mixins/statusManagerMixin';
import StatusManagerBase from '@satellite/modules/appointments/components/StatusManagerBase.vue';

/**
 * @displayName Status Manager
 */
export default {
  name: 'StatusManager',
  mixins: [statusManagerMixin],
  extends: StatusManagerBase,
  computed: {
    warehouse() {
      // Used by statusManagerMixin
      return this.$warehouse;
    }
  }
};
</script>

<style>
.stepper-header {
  box-shadow: none;
}
</style>
